import { FormGroup } from '@angular/forms';

export interface Plan
{
  name: string;
  type: string;
  features: string[];
  price: string;
  priceInfo: string;
}

export interface Addon
{
  code: string;
  name: string;
  icon: string;
  description: string;
  unitPrice: number;
  quantity: number;
  checked: boolean;
}

export interface SignUpForms
{
  pricing: FormGroup;
  personalData: FormGroup;
  businessData: FormGroup;
  checkout: FormGroup;
}

export interface SignUpInfo
{
  plans: Plan[];
  addons: Addon[];
}

export interface VerificationData
{
  Correo: string;
  Telefono: string;
}
export interface VerificationResponse
{
  isVerified: boolean;
  message: string;
}

export enum SignUpSteps
{
  'personal-data' = 1,
  'business-data' = 2,
  checkout = 3,
}

export interface SignUpData
{
  ItemsList: ItemList[];
  nombreUsuario: string;
  correoUsuario: string;
  claveUsuario: string;
  confirmPassword: string;
  telefonoContacto: string;
  codVerificacion: number;
  isVerified: boolean;
  nombreOrganizacion: string;
  numeroOrganizacion: string;
  razonSocial: string;
  codTipoSociedad: string;
  codTipoNegocio: string;
  codCategoriaNegocio: string;
  codPais: number;
  codDepartamento: number;
  codCiudad: number;
  direccionOrganizacion: string;
  direccionLatitud: number;
  direccionLongitud: number;
  cardName: string;
  cardNumber: string;
  cardMonth: string;
  cardYear: string;
  cardCVV: string;
  nombreFactura: string;
  rtn: null;
  organizacion: null;
  codPaisCO: number;
  codDepartamentoCO: number;
  codCiudadCO: number;
  codPostalCO: string;
  direccionCO: string;
  telefonoCO: string;
  subtotal: number;
  taxes: number;
  total: number;
  last4: string;
  logo: string | null;
  direccionFija: boolean;
  regimenFiscal: boolean;
  rtnCO: string;
  codigoPostal: number;

}

export interface ItemList
{
  Quantity: number;
  Checked: boolean;
  ProductId: string;
  Name: string;
  PriceId: string;
  Taxes: number;
  Unit: number;
  UnitAmount: number;
  Interval: string;
  Metadata: null;
  Order: null;
}


export interface cardsPrefix
{
  prefijo: string;
  tipo: string;
}
